module.exports = __webpack_public_path__ + "static/media/iphone 12 pro max banner4.cd593ae1.jpg";